import { useCookies } from 'react-cookie'
import { useAccountOpeningConnectors } from './useAccountOpeningConnectors'

export const ACCOUNT_OPENING_ENABLED_COOKIE = 'accountOpeningEnabled'

export const useAccountOpeningEnabled = (): boolean => {
  const [cookies] = useCookies([ACCOUNT_OPENING_ENABLED_COOKIE])
  const flag = cookies[ACCOUNT_OPENING_ENABLED_COOKIE]
  const { hasAny } = useAccountOpeningConnectors()

  return (flag === true || flag === 'true') && hasAny
}
